export default __webpack_public_path__ + "img/shareV2.7e4e10ce.svg";